import HealthRangeComparisonChartContainer from './HealthRangeComparisonChart'

export default HealthRangeComparisonChartContainer
